import Cookies from 'js-cookie';

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
    return new Promise(function (resolve, reject) {
        if (document.readyState === 'complete') {
            resolve(document);
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                resolve(document);
            });
        }
    });
};



document.ready().then(function () {

    const cookieName = 'agio-cpa';
    const acceptedCookie = Cookies.get(cookieName);

    if (!acceptedCookie) {

        const cookieBar = document.getElementById('cookie-bar');
        const cookiesAcceptButton = document.getElementById('close-cookies');

        cookieBar.style.display = "block";
        
        if(cookiesAcceptButton) {
            cookiesAcceptButton.addEventListener('click', function (event) {
                event.preventDefault();
                Cookies.set(cookieName, true);
                cookieBar.style.display = "none";
            });
        }
        
    }

});